<template>
	<div class="p4">
		<transaction-create-update-form
			@submit="handleSubmit"
			:initialPayload="initialPayload"
		>
			<div class="xs-12 flex xs-between mt6" slot-scope="{ onSubmit }">
				<!-- This button is using scoped slot method onSubmit that actually emits @submit event -->
				<j-button @click="onSubmit" :isLoading="isLoading">{{
					$t("update")
				}}</j-button>
				<j-button
					@click="$emit('cancel')"
					:isDisabled="isLoading"
					type="bordered"
					>{{ $t("cancel") }}</j-button
				>
			</div>
		</transaction-create-update-form>
	</div>
</template>

<script>
import TransactionCreateUpdateForm from "./TransactionCreateUpdateForm"
import JButton from "@/components/JButton"
import api from "../api"
import { transformDateTime } from "@/utils/"
import dayjs from "dayjs"

export default {
	components: { TransactionCreateUpdateForm, JButton },
	props: {
		policyId: {
			type: String,
			required: true,
			default: ""
		},
		transactionId: {
			type: String,
			required: true,
			default: ""
		},
		initialPayload: {
			type: Object,
			required: true,
			default: () => ({})
		}
	},
	data() {
		return {
			isLoading: false
		}
	},
	methods: {
		async handleSubmit(payload) {
			if (!this.policyId) return

			const currentDateTime = dayjs().format("DD/MM/YYYY HH:mm:ss")

			this.isLoading = true
			const res = await api.updateTransaction({
				transactionId: this.transactionId,
				input: {
					...payload,
					dateTime:
						payload.dateTime !== ""
							? transformDateTime(payload.dateTime)
							: transformDateTime(currentDateTime),
					policyId: this.policyId
				}
			})
			this.isLoading = false

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// If all good emit event
			this.$emit("transaction:updated")
		}
	}
}
</script>
